import { gql } from '../utils/general';

export const healthCheck = gql`
  query healthCheck($entityId: Int!) {
    stories(where: {entityId: {_eq: $entityId}}, limit: 1, offset: 0) {
      _id
    }
  }
`;

export const getStoryContentsById = gql`
  query GetStoryContentsById($storyId: String!, $entityId: Int, $limit: Int!) {
    storyContents(
      where: { storyId: { _eq: $storyId }, entityId: { _eq: $entityId }, story: { deletedAt: { _is_null: true } } }
      limit: $limit
    ) {
      _id
      content
      contentHtml
      createdAt
      format
      group
      layout
      order
      storyId
      entityId
      title
      type
      updatedAt
      active
      author {
        title
        _id
        firstName
        lastName
        email
        opengovId
      }
      story {
        _id
        title
        description
        embeds {
          embedId
          storyId
        }
      }
      contentChartConfig {
        id
        contentId
        storyId
        config
        type
      }
    }
  }
`;

export const getStoryContentsByIds = gql`
  query GetStoryContentsById($storyIds: [String!]) {
    storyContents(where: { storyId: { _in: $storyIds } }) {
      _id
      content
      contentHtml
      createdAt
      format
      group
      layout
      order
      storyId
      entityId
      title
      type
      updatedAt
      active
      author {
        title
        _id
        firstName
        lastName
        email
        opengovId
      }
      contentChartConfig {
        id
        contentId
        storyId
        config
        type
      }
    }
  }
`;

export const getStoryById = gql`
  query GetStoryById($id: String!) {
    resource: stories(where: { _id: { _eq: $id }, deletedAt: { _is_null: true } }) {
      storyKey
      thumbnail
      thumbnailRelativePath
      title
      description
      entityId
    }
  }
`;

export const getStoryAndPublicationCustomCss = gql`
  query GetStoryAndPublicationCustomCss($id: String!) {
    resource: stories_by_pk(_id: $id) {
      customCssCode
      folder {
        publication {
          customCssCode
        }
      }
    }
  }
`;

export const getTemplateById = gql`
  query GetTemplateById($id: String!) {
    resource: storyTemplates_by_pk(_id: $id) {
      entityId
      thumbnail
      thumbnailRelativePath
      title
      description
      customCssCode
    }
  }
`;

export const getFontsForEntity = gql`
  query GetFontsForEntity($entityId: Int!) {
    settings: entityStorySettings_by_pk(entityId: $entityId) {
      fontsHeadline
      fontsParagraph
    }
  }
`;

export const getTemplateContentsById = gql`
  query GetTemplateContentsById($storyTemplateId: String!, $limit: Int!) {
    storyContents: storyTemplateContents(where: { storyTemplateId: { _eq: $storyTemplateId } }, limit: $limit) {
      _id
      active
      content
      contentHtml
      description
      entityId
      format
      group
      layout
      order
      storyTemplateId
      title
      type
      author {
        _id
        email
        firstName
        lastName
        opengovId
        title
      }
    }
  }
`;

export const getInternalStory = gql`
  query GetInternalStory($id: String!) {
    internalStory: internalPublishedStory(where: { storyId: { _eq: $id } }) {
      contentHtml
      story {
        entityId
      }
    }
  }
`;

export const getPublishedStories = gql`
  query GetPublishedStories($entityId: Int!) {
    stories(where: { entityId: { _eq: $entityId }, state: { _eq: published } }) {
      _id
      description
      title
      updatedAt
      story_key: storyKey
    }
    count: stories_aggregate(where: { entityId: { _eq: $entityId }, state: { _eq: published } }) {
      aggregate {
        count
      }
    }
  }
`;

export const getPublishedStoriesCount = gql`
  query GetPublishedStoriesCount($entityId: Int!) {
    count: stories_aggregate(where: { entityId: { _eq: $entityId }, state: { _eq: published } }) {
      aggregate {
        count
      }
    }
  }
`;

export const portalStories = gql`
  query GetPortalStories($entityId: Int!) {
    count: portalStory_aggregate(where: { entityId: { _eq: $entityId } }) {
      aggregate {
        count
      }
    }
    portalStory(where: { entityId: { _eq: $entityId } }) {
      _id
      order
      story {
        _id
        description
        title
        updatedAt
        story_key: storyKey
        public_url: publicUrl
      }
      entity_id: entityId
    }
  }
`;

export const getSubFoldersForFolder = gql`
  query getSubFoldersForFolder($folderId: uuid!) {
    storyFolders(where: { id: { _eq: $folderId } }) {
      id
      title
      stories_aggregate {
        aggregate {
          count
        }
      }
      subFolders {
        id
        title
        subFolders {
          id
          title
          subFolders {
            id
            title
            subFolders {
              id
              title
              subFolders {
                id
                title
                subFolders {
                  id
                  title
                  subFolders {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getPublicationDataForPreview = gql`
  fragment storyFolderFields on storyFolders {
    id
    title
    order
    subFolders {
      id
      title
      parentFolderId
      order
    }
    parentFolderId
    stories(where: { deletedAt: { _is_null: true }, state: { _eq: published } }, order_by: { order: asc }) {
      id: _id
      title
      publicUrl
      customCssCode
      order
    }
  }
  query getPublicationDataForPreview($publicationId: uuid!) {
    publication: publications_by_pk(id: $publicationId) {
      title
      id
      entityId
      description
      publicUrl
      status
      thumbnailPath
      updatedAt
      setTocAsLandingPage
      customCssCode
      publicationBranding {
        logoUrl
        fontStyle
        activeBackgroundColor
        activeFontColor
        enableLogoNavigation
        idleBackgroundColor
        idleFontColor
        isNavigationMenuSticky
        showLogoOnFooter
        updatedAt
        enableGoogleTranslate
      }
      publicationFooterSettings {
        fontColors
        backgroundColors
        mediaLinks
        updatedAt
      }
      publicationNavigationMenuItems(order_by: { order: asc }) {
        order
        title
        id
        publicationNavigationMenuStories(order_by: { order: asc }) {
          id
          menuId
          order
          story {
            title
            _id
          }
          displayName
          storyId
          createdAt
        }
      }
      publicationTOCSettings {
        headerImageUrl
        headerHeightSize
        columnLayoutNumber
        menuTitle
        pageTitle
        description
        showTableOfContents
        updatedAt
      }
      publicationFolders: storyFolders(
        where: {
          publicationId: { _eq: $publicationId }, deletedAt: { _is_null: true }
        }
      )
      { ...storyFolderFields }
    }
    publicationRootFolder: publicationFolders(
      where: {
        publicationId: { _eq: $publicationId }
        storyFolder: { parentFolder: { parentFolderId: { _is_null: true } } }
      }
    ) {
      folderId
    }
  }
`;

export const getFontsAndGAIdForEntity = gql`
  query GetFontsAndGAIdForEntity($entityId: Int!) {
    settings: entityStorySettings_by_pk(entityId: $entityId) {
      fontsHeadline
      fontsParagraph
      googleAnalyticsId
    }
  }
`;

export const getStoriesDataToPublish = gql`
  query getStoriesDataToPublish($storiesIds: [String!]) {
    stories(where: { _id: { _in: $storiesIds } }) {
      _id
      title
      description
      thumbnail_relative_path: thumbnailRelativePath
      entity_id: entityId
      thumbnail
      public_url: publicUrl
      state
      story_key: storyKey
      customCssCode
      isFollowable
      folder {
        publication {
          customCssCode
        }
      }
    }
  }
`;

export const getProposalsInStories = gql`
  query getProposalsInStories($storiesIds: [String!]) {
    storyBudgetProposals(where: { storyId: { _in: $storiesIds } }) {
      id
      budgetId
      proposalId
      story {
        entityId
      }
    }
  }
`;

export const getAllAddedProposalsInStories = gql`
  query getAllAddedProposalsInStories($storyId: String!) {
    storyBudgetProposals(where: { storyId: { _eq: $storyId } }) {
      proposalId
      budgetId
    }
  }
`;

export const checkStoryTitleExistsQuery = gql`
  query checkStoryTitleExists($folderId: uuid!, $title: String!, $entityId: Int!) {
    stories_aggregate(where: {deletedAt: { _is_null: true }, folderId: {_eq: $folderId}, title: {_eq: $title}, entityId: {_eq: $entityId}}) {
      aggregate {
        count
      }
    }
  }
`;
